import { render, staticRenderFns } from "./video-player-controls.vue?vue&type=template&id=be4f02c0&"
import script from "./video-player-controls.vue?vue&type=script&lang=ts&"
export * from "./video-player-controls.vue?vue&type=script&lang=ts&"
import style0 from "./video-player-controls.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../../../../tmp/ffsecurity-ui/node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports